import type { MarketplaceKey } from "@porsche-customer/slfinrtl-context-types"

export const analyticsEnabledMarketplaces: MarketplaceKey[] = [
	"am",
	"ar",
	"at",
	"au",
	"az",
	"ba",
	"be",
	"bg",
	"bh",
	"bn",
	"bo",
	"br",
	"ca",
	"ch",
	"cl",
	"cn",
	"co",
	"cr",
	"cw",
	"cy",
	"cz",
	"de",
	"do",
	"ec",
	"ee",
	"eg",
	"es",
	"fr",
	"gb",
	"ge",
	"gp",
	"gr",
	"gt",
	"hk",
	"hn",
	"hr",
	"hu",
	"id",
	"ie",
	"il",
	"in",
	"it",
	"jm",
	"jo",
	"jp",
	"kr",
	"kw",
	"kz",
	"lb",
	"lk",
	"lt",
	"lu",
	"lv",
	"ma",
	"md",
	"mk",
	"mn",
	"mt",
	"mu",
	"mx",
	"my",
	"nc",
	"nl",
	"no",
	"nz",
	"om",
	"pa",
	"pe",
	"pf",
	"ph",
	"pl",
	"pr",
	"pt",
	"py",
	"qa",
	"re",
	"ro",
	"rs",
	"sa",
	"sg",
	"si",
	"sk",
	"sv",
	"th",
	"tn",
	"tr",
	"tt",
	"tw",
	"ua",
	"us",
	"uy",
	"uz",
	"vn",
	"xa",
	"xd",
	"xp",
	"za",
]
